module.exports = __webpack_public_path__ + "ffc1e15f3a8f0fbe1d84e2fa04c8cc86.png";